import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "copyable-text" }

import { Check, CopyDocument } from '@element-plus/icons-vue';
import { ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CopyableText',
  props: {
    text: {
        type: String,
        required: true,
    },
},
  setup(__props) {

const props = __props;


const isTextCopied = ref(false);

const copyToClipboard = async () => {
    try {
        await navigator.clipboard.writeText(props.text);
        isTextCopied.value = true;
        setTimeout(() => {
            isTextCopied.value = false;
        }, 3000);
    } catch (e) {
        isTextCopied.value = false;
    }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_input, {
      value: props.text,
      disabled: ""
    }, null, 8, ["value"]),
    _createVNode(_component_el_button, {
      size: "small",
      class: "button is-primary is-radius-small",
      icon: isTextCopied.value ? _unref(Check) : _unref(CopyDocument),
      onClick: copyToClipboard
    }, null, 8, ["icon"])
  ]))
}
}

})